(function (angular) {
	'use strict';

	angular
		.module('settingsModule')
		.controller('ChangePasswordSettings', [
			'globalConfig',
			'SettingsFactory',
			'urlFactory',
			ChangePasswordSettingsFunction
		]);

	function ChangePasswordSettingsFunction(
		globalConfig,
		SettingsFactory,
		urlFactory
	) {
		var passwordSettings = this;

		passwordSettings.submit = function() {			
			SettingsFactory.password.update(passwordSettings.changePasswordForm, passwordSettings.currentPassword, passwordSettings.newPassword)
				.then(function() {
					urlFactory.submitFormById('changePasswordForm');
				}).catch(function() {
					passwordSettings.formSubmitted = false;
				});
		};

		passwordSettings.$onInit = function() {
			angular.merge(passwordSettings, globalConfig);
		};
	}
})(window.angular);